// extracted by mini-css-extract-plugin
export default {"base":"vp_RemnP","sizeMedium":"vp_I2wjb","sizeSmall":"vp_vFed8","colorContrast":"vp_ECqeb","colorPrimary":"vp_wdI8Q"};